import { render } from "./PledgeCardTitle.vue?vue&type=template&id=6ad0af04"
import script from "./PledgeCardTitle.vue?vue&type=script&lang=js"
export * from "./PledgeCardTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__